module.exports = __webpack_public_path__ + "static/media/Bullet.70cd7455.svg";